import styles from "./InfoPage.module.scss"; // Імпортуємо SCSS файл для стилів
import Nav from "@/components/Header/Nav/Nav";
import Footer from "@/components/Footer/Footer";
import CookiePopupButton from "@/components/CookieBanner/CookiePopupButton.tsx";
import { useEffect } from "react";
import { Helmet } from "react-helmet";

const Retouren = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Скролимо в верх сторінки
  }, []);
  return (
    <div>
      <Helmet>
        <title>
          Retouren & Umtausch – HIXA – DSG Getriebe Reparatur & Wartung
        </title>
      </Helmet>

      <Nav />
      <h2 className={` sectionContainer ${styles.title}`}>
        Retouren & Umtausch
      </h2>
      <div className="container sectionContainer sectionContainerWhite">
        <p className={styles.infoPageText}>
          Das gesetzliche Widerrufsrecht bleibt hiervon unberührt. Details
          hierzu finden Sie in unserer{" "}
          <a className={styles.infoPageLink} href="/widerrufsrecht">
            Widerrufsbelehrung
          </a>
          .
        </p>

        <p className={styles.infoPageDate}>Rückgabebedingungen:</p>

        <p className={styles.infoPageText}>
          1. Rückgabefristen
          <br />
          • Rückgabe oder Umtausch innerhalb von 14 Tagen nach Erhalt der Ware
          möglich.
          <br />• Die Ware muss vollständig, unbeschädigt und in
          Originalverpackung zurückgeschickt werden.
        </p>
        <br></br>
        <p className={styles.infoPageText}>
          2. Ablauf der Rücksendung
          <br />
          • Bitte kontaktieren Sie uns vorab per E-Mail, um die Rücksendung
          anzumelden.
          <br />
          • Sie erhalten von uns ein Rücksendeformular und die genaue Adresse.
          <br />• Unangekündigte Rücksendungen können nicht bearbeitet werden.
        </p>
        <br></br>
        <p className={styles.infoPageText}>
          3. Kosten der Rücksendung
          <br />
          • Innerhalb Deutschlands übernehmen wir die Rücksendekosten bei
          Reklamationen oder Pfandrückgaben.
          <br />• Rücksendungen aus dem EU-Ausland trägt der Kunde, sofern
          nichts anderes vereinbart wurde.
        </p>
        <br></br>
        <p className={styles.infoPageText}>
          4. Austausch und Ersatz
          <br />
          • Bei Defekten während der Garantiezeit (12 Monate) prüfen wir die
          Ware.
          <br />
          • Nach positiver Prüfung reparieren oder ersetzen wir die Komponente
          kostenlos.
          <br />• Auf Wunsch ist ein schneller Austausch gegen Kaution möglich:
          Sie erhalten sofort eine Ersatz-Mechatronik, die Kaution wird nach
          Rücksendung erstattet.
        </p>
        <br></br>
        <p className={styles.infoPageText}>
          5. Ausnahmen vom Umtausch
          <br />
          • Unsachgemäßer Einbau oder falsches Anlernen
          <br />
          • Verwendung von falschem Getriebeöl
          <br />
          • Mechanische Schäden durch unsachgemäße Handhabung
          <br />• Manipulation der Software oder unautorisierte Reparaturen
        </p>
        <br></br>
        <p className={styles.infoPageText}>
          6. Garantiebedingungen
          <br />
          • 12 Monate Garantie auf reparierte oder generalüberholte
          Mechatroniken.
          <br />
          • Voraussetzung: Einbau durch Fachwerkstatt, Nachweis per Rechnung.
          <br />• Genaue Bedingungen finden Sie in unseren [AGB] und im
          Abschnitt „Garantie“.
        </p>
      </div>
      <CookiePopupButton></CookiePopupButton>
      <Footer />
    </div>
  );
};

export default Retouren;
